export type StudentCostOverviewPdfExportType = "totalCostOverview" | "balanceList";

export type StudentCostOverviewPdfExportPhase =
  | "loadData"
  | "buildOverview"
  | "resolveLogo"
  | "renderPdfBlob"
  | "triggerDownload";

export interface StudentCostOverviewPdfExportDiagnostics {
  exportType: StudentCostOverviewPdfExportType;
  fileName: string;
  studentId: string;
  autovioUserId: string;
  drivingSchoolId: string;
  invoiceCount?: number;
  creditNoteCount?: number;
  manualRefundCount?: number;
  studentManualRefundCount?: number;
  hasFundingInstructions: boolean;
  hasLogoUrl: boolean;
}

export class StudentCostOverviewPdfExportError extends Error {
  constructor(
    public readonly phase: StudentCostOverviewPdfExportPhase,
    public readonly diagnostics: StudentCostOverviewPdfExportDiagnostics,
    public readonly originalError: unknown,
  ) {
    super(`Student cost overview PDF export failed during ${phase}`);
    Object.setPrototypeOf(this, StudentCostOverviewPdfExportError.prototype);
  }
}

export async function runStudentCostOverviewPdfExportPhase<T>(
  phase: StudentCostOverviewPdfExportPhase,
  diagnostics: StudentCostOverviewPdfExportDiagnostics,
  action: () => T | Promise<T>,
): Promise<T> {
  try {
    return await action();
  } catch (error) {
    throw new StudentCostOverviewPdfExportError(phase, diagnostics, error);
  }
}
